import { ProfilePageTabId } from '@colonist/clientforge';
import { createDivIn, createHeaderIn, createSelectIn, createImgIn, createSpanIn } from '../ui_utils/DomUtils.ts';
import { UIPopupProfileController } from './UIPopupProfileController.ts';
import { LobbyImage } from '@colonist/types';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIPopupManager } from '../ui_popup/UIPopupManager.ts';
import { showProfileDialog } from './showProfileDialog.ts';
export function getProfilePopupElementId(id, isPopup) {
    return `${isPopup ? 'profile_popup_' : ''}` + id;
}
export class UIViewProfilePopup {
    static init(username, selectedTab) {
        const currentUsername = UIViewProfilePopup.previousUsernames[UIViewProfilePopup.previousUsernames.length - 1];
        if (currentUsername == username) return;
        UIViewProfilePopup.removeUsernameFromHistory(username);
        UIViewProfilePopup.previousUsernames.push(username);
        void UIViewProfilePopup.create(username, selectedTab);
    }
    static removeUsernameFromHistory(username) {
        UIViewProfilePopup.previousUsernames = UIViewProfilePopup.previousUsernames.filter((existingUsername)=>existingUsername != username);
    }
    static async create(username, selectedTab = ProfilePageTabId.Overview) {
        UIViewProfilePopup.isNavigating = true;
        UIPopupManager.closeAllPopups();
        const stickyPlayerInfo = await UIViewProfilePopup.getStickyPlayerInfo(username);
        if (stickyPlayerInfo == undefined) {
            UIViewProfilePopup.removeUsernameFromHistory(username);
            UIViewProfilePopup.isNavigating = false;
            return;
        }
        showProfileDialog({
            username: username,
            showBackButton: UIViewProfilePopup.previousUsernames.length > 1,
            onBack: ()=>UIViewProfilePopup.handleBack(),
            onMount: (element)=>{
                UIViewProfilePopup.isNavigating = false;
                UIViewProfilePopup.createProfileHTML(element, username);
                new UIPopupProfileController(username, stickyPlayerInfo, selectedTab);
            },
            onDialogClosed: ()=>UIViewProfilePopup.handleDialogClosed()
        });
    }
    static handleBack() {
        if (UIViewProfilePopup.previousUsernames.length < 2) return;
        UIViewProfilePopup.previousUsernames.pop();
        const previousUsername = UIViewProfilePopup.previousUsernames[UIViewProfilePopup.previousUsernames.length - 1];
        void UIViewProfilePopup.create(previousUsername);
    }
    static handleDialogClosed() {
        if (UIViewProfilePopup.isNavigating) return;
        UIViewProfilePopup.previousUsernames.length = 0;
    }
    static async getStickyPlayerInfo(username) {
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserProfile.stickyPlayerInfo(username), undefined);
        if (response == undefined) {
            return;
        }
        return response.json;
    }
    static createProfileHTML(container, username) {
        const mainContainer = createDivIn(container, 'main_container_block main_container_singleton_page profile-page-main-container profile-popup-container');
        createDivIn(mainContainer, 'profile-page-sidebar', 'profile_popup_profile_sidebar');
        const contentContainer = createDivIn(mainContainer, 'singleton_page_main_section');
        UIViewProfilePopup.createStickyPlayerInfo(contentContainer, username);
        UIViewProfilePopup.createOverviewSection(contentContainer);
        UIViewProfilePopup.createRankedSection(contentContainer);
        UIViewProfilePopup.createHistorySection(contentContainer);
        UIViewProfilePopup.createItemsSection(contentContainer);
    }
    static createStickyPlayerInfo(container, username) {
        const stickyPlayerInfo = createDivIn(container, 'sticky_player_info');
        const textContainer = createDivIn(stickyPlayerInfo, 'sticky_player_info_text_container', 'profile_popup_sticky_player_info_text_container');
        createDivIn(textContainer, 'profile-icon-wrapper', 'profile_popup_sticky_player_info_icon');
        createHeaderIn(textContainer, {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: username
            }
        }, 'sticky_player_info_username', 'profile_popup_sticky_player_info_username', 'H1');
        const dropdown = createDivIn(textContainer, 'component-dropdown-container', 'profile_popup_sticky_player_info_dropdown');
        const dropdownButton = createDivIn(dropdown, 'component-dropdown-arrow', 'profile_popup_sticky_player_info_dropdown_button');
        createImgIn(dropdownButton, LobbyImage.DownArrow, 'component-icon-down-arrow');
        createDivIn(dropdown, 'component-dropdown-content');
    }
    static createOverviewSection(container) {
        const overviewSection = createDivIn(container, 'hidden static_center_scroll_profile', 'profile_popup_overview-container');
        createHeaderIn(overviewSection, {
            key: 'strings:profilePage.overview.title'
        }, '', '', 'H2');
        createDivIn(overviewSection, '', 'profile_popup_overview_div');
    }
    static createRankedSection(container) {
        const rankedSection = createDivIn(container, 'hidden static_center_scroll_profile', 'profile_popup_ranked-container');
        const rankedHeader = createDivIn(rankedSection, 'profile_ranked_section_header');
        createHeaderIn(rankedHeader, {
            key: 'strings:profilePage.navigationTabs.ranked'
        }, '', '', 'H2');
        createSelectIn(rankedHeader, '', 'profile_popup_profile_ranked_season_dropdown', ()=>undefined);
        const rankedCardsContainer = createDivIn(rankedSection, 'ranked_mode_player_info_cards_container');
        UIViewProfilePopup.createRankedCard(rankedCardsContainer, 'profile_popup_ranked_mode_player_info_card_base', LobbyImage.GameModeBase, 'settlers of catan base game icon', {
            key: 'strings:leaderboardPage.gameModes.baseGame'
        }, 'base');
        UIViewProfilePopup.createRankedCard(rankedCardsContainer, 'profile_popup_ranked_mode_player_info_card_1v1', LobbyImage.GameMode1v1, 'colonist 1v1 game mode icon', {
            key: 'strings:leaderboardPage.gameModes.1v1'
        }, '1v1');
        this.createRankedCard(rankedCardsContainer, 'profile_popup_ranked_mode_player_info_card_rush', LobbyImage.GameModeRankedRush, 'colonist rush ranked game mode icon', {
            key: 'strings:leaderboardPage.gameModes.rush'
        }, 'rush');
        this.createRankedCard(rankedCardsContainer, 'profile_popup_ranked_mode_player_info_card_citiesandknights', LobbyImage.GameModeCnK, 'settlers of catan cities and knights icon', {
            key: 'strings:leaderboardPage.gameModes.citiesAndKnights'
        }, 'citiesandknights');
    }
    static createRankedCard(container, cardId, iconSrc, iconAlt, titleText, mode) {
        const card = createDivIn(container, 'ranked_mode_player_info_card');
        card.id = cardId;
        const cardHeader = createDivIn(card, 'ranked-card-header');
        const headerTitle = createDivIn(cardHeader, 'ranked-card-header-title');
        createImgIn(headerTitle, iconSrc, iconAlt);
        createSpanIn(headerTitle, '', titleText);
        const cardContent = createDivIn(card, 'ranked-card-content');
        createDivIn(cardContent, 'ranked_mode_player_progress_container', `profile_popup_ranked_mode_player_progress_${mode}_container`);
        createDivIn(cardContent, 'ranked_mode_player_stats_container', `profile_popup_ranked_mode_player_stats_${mode}_container`);
    }
    static createHistorySection(container) {
        const historySection = createDivIn(container, 'hidden static_center_scroll_profile', 'profile_popup_game-history-container');
        createHeaderIn(historySection, {
            key: 'strings:profilePage.history.title'
        }, '', '', 'H2');
        createDivIn(historySection, 'game-history-table-mount', 'profile_popup_game-history-table');
    }
    static createItemsSection(container) {
        const itemsSection = createDivIn(container, 'hidden static_center_scroll_profile', 'profile_popup_items-container');
        createHeaderIn(itemsSection, {
            key: 'strings:profilePage.navigationTabs.items'
        }, '', '', 'H2');
        const itemsContainer = createDivIn(itemsSection, 'profile_container');
        createDivIn(itemsContainer, '', 'profile_popup_profile_items_div');
    }
}
UIViewProfilePopup.previousUsernames = [];
UIViewProfilePopup.isNavigating = false;
